import util from './util'
import ACFPosts from './component-acf-posts'

let Authors = Vue.component('authors', {
	data() {
		return {
			posts: [],
			pushFix: true
		}
	},
	methods: {
		onClick: util.onClickDefaultLink
	},
	mounted() {
		util.getAuthors().then((response) => {

			console.log(response);

			function compare(a, b) {
				if (a.menu_order < b.menu_order) {
					return -1;
				}
				if (a.menu_order > b.menu_order) {
					return 1;
				}
				return 0;
			}

			let sorted = response.sort(compare);

			this.posts = sorted;
			this.pushFix = false;

		}).catch(() => {
			this.pushFix = false
		})
	},
	template: `
		<div>
			<transition-group name="fade" tag="div">
				<div v-for="author in posts" :key="author.id">
					<h1 v-html="author.title.rendered"></h1>
					<div class="section-content" v-html="author.author_bio"></div>
					<acf-posts :posts="author.author_posts" :headline="'Texts by ' + author.title.rendered"></acf-posts>
				</div>
			</transition-group>
			<div class="ajax-pushfix" v-if="pushFix"></div>
		</div>`
})

export default Authors
